<div class="main-panel">
  <!-- BEGIN : Main Content-->
  <div class="main-content">
    <div class="content-wrapper">


      <section id="configuration">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Real Time Log View</h4>
              </div>
              <div class="card-content">
                <div class="card-body card-dashboard table-responsive">
                  <table class="table table-striped table-bordered zero-configuration">
                    <thead>
                      <tr>
                        <th>User ID</th>
                        <th>Device Name</th>
                        <th>Verify Mode</th>
                        <th>Status</th>
                        <th>Check Time</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of Logs ">
                        <td>{{item.userId}}</td>
                        <td>{{item.deviceName}}</td>
                        <td>{{item.verifyMode}}</td>
                        <td>{{item.ioMode}}</td>
                        <td>{{item.ioTime}}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>User ID</th>
                        <th>Device Name</th>
                        <th>Verify Mode</th>
                        <th>Status</th>
                        <th>Check Time</th>

                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <h3 style="color: white">Please Wait ... </h3>
  </ngx-spinner>
